import { IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PropTypes from "prop-types";

const EmailIconButton = ({ email }) => {
  if (!email) {
    return null;
  }

  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = `mailto:${email}`;
      }}
      sx={{
        padding: "4px",
        "&:hover": {
          color: "#d32f2f",
          backgroundColor: "rgba(211, 47, 47, 0.08)",
        },
      }}>
      <EmailIcon fontSize="small" />
    </IconButton>
  );
};

EmailIconButton.propTypes = {
  email: PropTypes.string,
};

EmailIconButton.defaultProps = {
  email: null,
};

export default EmailIconButton;

